import React, { FunctionComponent, useState } from 'react';

import styles from './video-list.module.scss';
import { ButtonLoader } from '../button-loader/button-loader';
import {
  IYoutubeVideoProps,
  YoutubeVideo
} from '../youtube-video/youtube-video';

export interface IVideoListProps {
  videos: IYoutubeVideoProps[];
}

export const VideoList: FunctionComponent<IVideoListProps> = ({ videos }) => {
  const videosToShow = 4;
  const [videosListLength, setVideosCount] = useState(videosToShow);
  const videosList = videos.slice(0, videosListLength);

  const onButtonClick = (): void => {
    setVideosCount(videosListLength + videosToShow);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.videoList}>
        {videos &&
          videosList.map((video: IYoutubeVideoProps, i: number) => (
            <YoutubeVideo {...video} key={i} />
          ))}
      </div>
      {videosListLength < videos.length && (
        <div className={styles.loader}>
          <ButtonLoader buttonText="Load more" onClick={onButtonClick} />
        </div>
      )}
    </div>
  );
};
